import RulesModal from '../components/Modal/RulesModal'
import LottoGameCard, { LottoGameCardProps } from '../components/LottoGameCard'

interface LottoRoundScreenProps {
  gameTitle: string
  rulesContent: React.ReactNode
  rounds: LottoGameCardProps[]
}

export const LottoRoundScreen = ({
  gameTitle,
  rulesContent,
  rounds,
}: LottoRoundScreenProps) => {
  return (
    <>
      <div className="flex justify-between items-center mt-6 mb-6 w-full">
        <h3 className="text-[var(--heading-text)] font-semibold text-lg">
          {gameTitle}
        </h3>
        <div className="flex items-center gap-4">
          <RulesModal>{rulesContent}</RulesModal>
        </div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4 w-full">
        {rounds.map((item) => (
          <LottoGameCard key={item.id} {...item} />
        ))}
      </div>
    </>
  )
}
